import { MatPaginatorIntl } from '@angular/material/paginator';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var PaginatorI18n = /** @class */ (function () {
    function PaginatorI18n(translate, fuseTranslationLoaderService) {
        this.translate = translate;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    PaginatorI18n.prototype.getPaginatorIntl = function () {
        var paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = this.translate.instant('DATATABLE.ITEMS_PER_PAGE');
        paginatorIntl.nextPageLabel = this.translate.instant('DATATABLE.NEXT_PAGE');
        paginatorIntl.previousPageLabel = this.translate.instant('DATATABLE.PREVIOUS_PAGE');
        paginatorIntl.firstPageLabel = this.translate.instant('DATATABLE.FIRST_PAGE');
        paginatorIntl.lastPageLabel = this.translate.instant('DATATABLE.LAST_PAGE');
        paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
        return paginatorIntl;
    };
    PaginatorI18n.prototype.getRangeLabel = function (page, pageSize, length) {
        if (length === 0 || pageSize === 0) {
            return this.translate.instant('DATATABLE.RANGE_PAGE_1', { length: length });
        }
        length = Math.max(length, 0);
        var startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        var endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return this.translate.instant('DATATABLE.RANGE_PAGE_2', { startIndex: startIndex + 1, endIndex: endIndex, length: length });
    };
    return PaginatorI18n;
}());
export { PaginatorI18n };
